import React from "react";

function Watchuser() {
  return (
    <>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl font-semibold">
              Watch User Guide
            </h1>
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          <iframe
            className=""
            width="350"
            height="300"
            src="https://www.youtube.com/embed/uThcia-74YQ"
            title="How to create Menu Item for Web & POS Imdady Next-Gen RMS"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>

          <iframe
            width="350"
            height="300"
            src="https://www.youtube.com/embed/DsK-WTQmmZQ"
            title="How to add Ingredients for Stock Management"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>

          <iframe
            width="350"
            height="300"
            src="https://www.youtube.com/embed/spngfgcqebY"
            title="How to assign printers to categories and menu items Imdady NextGen RMS"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </>
  );
}

export default Watchuser;
